/**
 * Redirige /admin a la página de inicio que corresponde al usuario
 */

import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/stores/adminAuthStore';
import { adminHomePath } from '@/utils/adminHome';

export function AdminHomeRedirect() {
  const { admin } = useAdminAuth();
  return <Navigate to={adminHomePath(admin?.role)} replace />;
}
